import React from 'react';
import styles from './NavBar.module.css'; // Import the CSS module
import yzy_icon from "../../static_files/YZY1.png"
import {Link} from "react-router-dom";

function Navbar() {
    return (
        <nav className={styles.navContainer}>
            <div className={styles.navLeft}>
        <span>
         <img className={styles.logo} src={yzy_icon} alt="img"/>
        </span>
            </div>

            <div className={styles.navLinks}>
                <Link to="/">Home</Link>

                <a href="#address">Contract Address</a>
                <a href="#More">Learn More</a>
                <Link to="/terms">Terms & Conditions</Link>


            </div>

            <div className={styles.navRight}>
                <button
                    className={styles.buyNowBtn}
                    onClick={() => {
                        window.location.href = '#address';
                    }}
                >
                    Buy YZY
                </button>
            </div>
        </nav>
    );
}

export default Navbar;